import axios from 'axios';
import { lsKey } from '../../context/user.context';
import { AppConfig } from '../../Config/app-config';

const baseURL = AppConfig.apiUrl;

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  validateStatus: () => true,
});

api.interceptors.request.use(async (axiosConfig) => {
  const token = localStorage.getItem(lsKey);

  if (token) {
    axiosConfig.headers['Authorization'] = `Bearer ${token}`;
  }

  return axiosConfig;
});

export { api as axiosInstance };
